import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useContext, useMemo, memo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { ButtonPickerContext } from './ButtonPickerContext';
import { layouts, sizes, } from './constants';
const buttonBorderWidth = 1;
const selectedButtonBorderWidth = 2;
const buttonPaddings = {
    [sizes.small]: {
        horizontal: theme.spacing.x6,
        vertical: theme.spacing.x2,
    },
    [sizes.medium]: {
        horizontal: theme.spacing.x8,
        vertical: theme.spacing.x4,
    },
};
const borderWidthDifference = selectedButtonBorderWidth - buttonBorderWidth;
const selectedButtonPaddings = {
    [sizes.small]: {
        horizontal: styleUtils.remToPxValue(buttonPaddings.small.horizontal) - borderWidthDifference,
        vertical: styleUtils.remToPxValue(buttonPaddings.small.vertical) - borderWidthDifference,
    },
    [sizes.medium]: {
        horizontal: styleUtils.remToPxValue(buttonPaddings.medium.horizontal) - borderWidthDifference,
        vertical: styleUtils.remToPxValue(buttonPaddings.medium.vertical) - borderWidthDifference,
    },
};
const defaultProps = {
    id: '',
};
const ButtonPickerButton = ({ children, id = defaultProps.id, value, }) => {
    const { layout, onChange, pickerName, selectedValues, size, } = useContext(ButtonPickerContext);
    const isSelected = useMemo(() => (Array.isArray(selectedValues)
        ? selectedValues.includes(value)
        : selectedValues === value), [
        selectedValues,
        value,
    ]);
    const buttonStyles = useMemo(() => (css `
        ${styleUtils.buttonReset}
        ${styleUtils.borderBox}
        background-color: ${theme.colors.gray100};
        border-color: ${theme.colors.gray400};
        border-style: solid;
        border-width: ${styleUtils.rem(buttonBorderWidth)};
        color: ${theme.colors.gray700};
        padding-bottom: ${buttonPaddings[size].vertical};
        padding-left: ${buttonPaddings[size].horizontal};
        padding-right: ${buttonPaddings[size].horizontal};
        padding-top: ${buttonPaddings[size].vertical};
        ${layout === layouts.verticalLayout && css `
          width: 100%;
        `}
        ${size === sizes.small && theme.typeStyles.captionMediumStyles}
        ${size === sizes.medium && theme.typeStyles.captionLargeStyles}
        ${isSelected && css `
          border-color: ${theme.colors.gray700};
          border-width: ${styleUtils.rem(selectedButtonBorderWidth)};
          padding-bottom: ${styleUtils.rem(selectedButtonPaddings[size].vertical)};
          padding-left: ${styleUtils.rem(selectedButtonPaddings[size].horizontal)};
          padding-right: ${styleUtils.rem(selectedButtonPaddings[size].horizontal)};
          padding-top: ${styleUtils.rem(selectedButtonPaddings[size].vertical)};
        `}

        &:focus,
        &:hover {
          cursor: pointer;
        }

        &:active,
        &:focus,
        &:hover {
          border-color: ${theme.colors.gray500};
          ${isSelected && css `
            border-color: ${theme.colors.gray700};
          `}
        }
      `), [
        isSelected,
        layout,
        size,
    ]);
    const buttonId = useMemo(() => (id
        || `buttonPicker-${value.replace(' ', '_')}-${Math.random()}`), [
        id,
        value,
    ]);
    return (_jsx("button", Object.assign({ css: buttonStyles, id: buttonId, name: pickerName, onClick: onChange, type: "button", value: value }, { children: children })));
};
const MemoizedButtonPickerButton = memo(ButtonPickerButton);
export { MemoizedButtonPickerButton as ButtonPickerButton };
// MC-1068 Temporary hack for Storybook.
export default ButtonPickerButton;
